import PauseSVG from './PauseSVG';
import PlaySVG from './PlaySVG';
import NextSVG from './NextSVG';
import PreviousSVG from './PreviousSVG';
import VolumeSVG from './VolumeSVG';
import VolumeLoudSVG from './VolumeLoudSVG';
import MuteSVG from './MuteSVG';
export { PauseSVG, PlaySVG, NextSVG, PreviousSVG, VolumeSVG, VolumeLoudSVG, MuteSVG };